import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';
import { ConnectedRouter } from 'connected-react-router';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function createRouterContainer(defaultHistory, opts) {
  var options = _objectSpread({
    withRef: false
  }, opts);

  var finalDefaultHistory = defaultHistory || null;
  var propTypes = {
    history: finalDefaultHistory !== null ? PropTypes.object : PropTypes.object.isRequired
  };
  var defaultProps = finalDefaultHistory !== null ? {
    history: finalDefaultHistory
  } : {};
  return function (WrappedComponent) {
    var RouterContainer =
    /*#__PURE__*/
    function (_Component) {
      _inherits(RouterContainer, _Component);

      function RouterContainer() {
        _classCallCheck(this, RouterContainer);

        return _possibleConstructorReturn(this, _getPrototypeOf(RouterContainer).apply(this, arguments));
      }

      _createClass(RouterContainer, [{
        key: "render",
        value: function render() {
          var _this = this;

          var history = this.props.history;

          var props = _objectSpread({}, this.props);

          if (options.withRef) {
            props.ref = function (c) {
              _this.wrappedInstance = c;
            };
          }

          return React.createElement(ConnectedRouter, {
            history: history
          }, React.createElement(WrappedComponent, props));
        }
      }], [{
        key: "getWrappedInstance",
        value: function getWrappedInstance() {
          invariant(options.withRef, 'To access the wrapped instance, you need to specify `{ withRef: true }` as the second argument of the createRouterContainer() call.');
          return this.wrappedInstance;
        }
      }]);

      return RouterContainer;
    }(Component);

    RouterContainer.propTypes = propTypes;
    RouterContainer.defaultProps = defaultProps;
    RouterContainer.displayName = "RouterContainer(".concat(getDisplayName(WrappedComponent), ")");
    RouterContainer.WrappedComponent = WrappedComponent;
    return hoistStatics(RouterContainer, WrappedComponent);
  };
}


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-app/es/createRouterContainer.js
// module id = null
// module chunks = 